
export { CollectionName } from "/codebuild/output/src1740448103/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"